import React, { FC } from 'react'
import styled from '@emotion/styled'

import backIcon from '../../assets/back-icon.png'

interface PageHeaderProps {
    className?: string
    title?: string
    right?: React.ReactNode
    onBack?: () => void
}

export const PageHeader: FC<PageHeaderProps> = ({ className, title, right, onBack }) => {
    return (
        <Wrapper className={className}>
            <h2 onClick={() => onBack && onBack()}>
                {onBack && <img src={backIcon} alt="" />} {title || 'Metasill'}
            </h2>
            <div className="right">{right}</div>
        </Wrapper>
    )
}

const Wrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding-top: 72px;
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(47, 46, 46, 1);
    h2 {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 0;
        font-family: Roboto-Medium;
        font-size: 24px;
        color: #000000;
        letter-spacing: 0;
        line-height: 28px;
        font-weight: 500;
        cursor: pointer;
        img {
            width: 30px;
            height: 30px;
            margin-right: 10px;
        }
    }

    @media (max-width: 576px) {
        h2 {
            img {
                width: 20px;
                height: 20px;
                margin-right: 6px;
            }
        }
    }
`
